<div #myModal class="modal-container" [class.is-open]="isOpen" (click)="close()">
    <div #content class="content" (click)="$event.stopPropagation()">
      <div class="f-flex justify-content-between align-items-center w-100 modal-header">
          <h3>
            {{title}}
          </h3>
          <div class="close-section">
            <sketch-icon-button  opt="blank" text="Close" size="large" (click)="close( )"></sketch-icon-button>
          </div>
      </div>
      <div class="modal-body">
      <ng-content></ng-content>
      </div>
    </div>
  </div>